import {
    Container,
    Grid,
    Typography,
    Box,
    useTheme,
    Paper,
    ToggleButtonGroup,
    ToggleButton,
    Fade,
    Tooltip,
    Button
} from '@mui/material';
import { RefreshCw, Edit2Icon, X } from 'lucide-react';

import LicenseStatusCard from './LicenseStatusCard';
import ContractDatesCard from './ContractDatesCard';
import { Link } from 'react-router-dom';
import { LicenceType } from '../../../types/LicenceType';
import ModalEditLicence from './ModalEditLicence';
import { useState } from 'react';
import { AlertConfirm, AlertInfo } from '../../../components/Alerts/Alert';
import { api } from '../../../services/api';
import moment from 'moment';
import SimpleBackdrop from '../../../components/Loading/Simplebackdrop';

type LicenceDashboardType = {
    licence: Partial<LicenceType | null>
    setLicence: React.Dispatch<React.SetStateAction<Partial<LicenceType> | null>>
}

const LicenseDashboard = ({ licence, setLicence }: LicenceDashboardType) => {
    const theme = useTheme();
    const [openModalEdit, setOpenModalEdit] = useState(false);
    const [load, setLoad] = useState(false);

    async function encerrarLicence() {
        AlertConfirm({
            icon: 'info',
            title: 'Encerrar Licença do escritorio',
            text: 'Ao executar isto o acesso deste escritorio será bloqueado'
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoad(true);
                try {
                    const dataDb = {
                        id_licence: licence?.id_licence,
                        final_licence: moment().format("YYYY-MM-DD"),
                        nome_plano_licence: "Licença Encerrada pelo Administrador",
                        licence_status: 'expired'
                    };
                    const response = await api.post(`/updatelicence`, dataDb);
                    console.log(response);
                    if (response.data.success) {
                        AlertInfo({ icon: 'success', title: 'Licença Encerrada' });
                        setLicence({ ...licence, ...dataDb });
                    }else if(response.data.error){
                        AlertInfo({ icon: 'error', title: response.data.msg });
                    }
                } catch (error) {
                    console.log(error);
                    AlertInfo({ icon: 'error', title: 'Falha na conexão' });
                }
                setLoad(false);
            }
        });
    }

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <ModalEditLicence
                open={openModalEdit}
                setOpen={setOpenModalEdit}
                licence={licence}
                setLicence={setLicence}
            />
            <SimpleBackdrop open={load} />
            <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' } }}>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        fontWeight: 600,
                        mb: { xs: 2, sm: 0 },
                        color: theme.palette.primary.main,
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            bottom: -8,
                            left: 0,
                            width: 60,
                            height: 4,
                            borderRadius: 2,
                            backgroundColor: theme.palette.primary.main
                        }
                    }}
                >
                    Licença de Uso SysproJud
                </Typography>

                <Paper elevation={0} sx={{ p: 0.5 }}>
                    <ToggleButtonGroup
                        value={licence?.licence_status}
                        exclusive
                        aria-label="license status filter"
                        size="small"
                    >
                        <ToggleButton value="active" aria-label="active license">
                            <Tooltip title="Active License">
                                <Box sx={{ px: 1 }}>Atual</Box>
                            </Tooltip>
                        </ToggleButton>
                        <ToggleButton value="expiring" aria-label="expiring license">
                            <Tooltip title="Expiring Soon">
                                <Box sx={{ px: 1 }}>Anteriores</Box>
                            </Tooltip>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Paper>
            </Box>

            <Fade in={true} timeout={800}>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <LicenseStatusCard
                            licenseStatus={licence?.licence_status || ""}
                            inicio_licence={licence?.inicio_licence || ""}
                            final_licence={licence?.final_licence || ""}
                            chave_licence={licence?.chave_licence}
                            nome_plano_licence={licence?.nome_plano_licence}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <ContractDatesCard
                            inicio_licence={licence?.inicio_licence || ""}
                            final_licence={licence?.final_licence || ""}
                            licenseStatus={licence?.licence_status || ""}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<RefreshCw />}
                            color='success'
                            fullWidth
                            onClick={() => setOpenModalEdit(true)}
                        >
                            Gerar Nova Licença
                        </Button>
                    </Grid>
                    <Grid size={{ xs: false, sm: 4 }}></Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Button
                            variant="contained"
                            size="large"
                            startIcon={<X />}
                            color='error'
                            fullWidth
                            onClick={encerrarLicence}
                        >
                            Encerrar Licença
                        </Button>
                    </Grid>
                </Grid>
            </Fade>
        </Container>
    );
};

export default LicenseDashboard;